"use client"

import HomeDetailsWrapperAccordion from "../home-details-wrapper-accordion"
import { useWorkscopeLabelStyle, WORKSCOPE_LABEL_COLORS } from "../home-details-wrapper-accordion"
import FormSelectInput from "../../../../shared/components/form-inputs/form-select-input"
import FormMultiSelectInput from "../../../../shared/components/form-inputs/form-multi-select-input"
import FormTextInput from "@/shared/components/form-inputs/form-text-input"
import FormTextareaInput from "../../../../shared/components/form-inputs/form-textarea-input"
import DateStampedTextarea from "../../../../shared/components/form-inputs/form-date-stamped-textarea-input"
import { workScopeStatusOptions } from "../../constants/options"
import { HomeWithHomeOwnerFormType } from "../../schema/home-with-home-owner.schema"
import { useFormContext, useWatch } from "react-hook-form"
import { useClaimedByOptions } from "../../hooks/use-claimed-by-options"
import { useWorkscopeClaimedBySync } from "../../hooks/use-workscope-claimed-by-sync"
import { GoodwillToggleLabel } from "../goodwill-toggle-label"

const goodwillGreenStyle = { color: WORKSCOPE_LABEL_COLORS.goodwill } as const
const BASE_FIELD_NAME = "home.interiorPaintInfo"

function HomeInteriorPaintForm() {
    const goodwillLabelStyle = useWorkscopeLabelStyle(true) ?? goodwillGreenStyle
    const { control, setValue, getValues } = useFormContext<HomeWithHomeOwnerFormType>()
    const { options: claimedByOptions, loading: claimedByLoading } = useClaimedByOptions()
    const goodwillInteriorPaintOn = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillInteriorPaintOn` })
    
    // Watch status field and claimed by field
    const interiorPaint = useWatch({ control, name: `${BASE_FIELD_NAME}.interiorPaint` })
    const claimedBy = useWatch({ control, name: `${BASE_FIELD_NAME}.claimedBy` })
    const goodwillInteriorPaint = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillInteriorPaint` })
    const goodwillInteriorPaintClaimedBy = useWatch({
        control,
        name: `${BASE_FIELD_NAME}.goodwillInteriorPaintClaimedBy`,
    })

    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: interiorPaint,
        claimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.claimedBy`,
        setValue,
        getValues,
    })
    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: goodwillInteriorPaint,
        claimedBy: goodwillInteriorPaintClaimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.goodwillInteriorPaintClaimedBy`,
        setValue,
        getValues,
        enabled: !!goodwillInteriorPaintOn,
    })

    return (
        <HomeDetailsWrapperAccordion 
            heading="Interior Paint"
            wrapperClassName="xl:grid-cols-2"
        >
            <FormSelectInput
                inputGroupProps={{
                    label: <GoodwillToggleLabel title="Interior Paint" toggleName={`${BASE_FIELD_NAME}.goodwillInteriorPaintOn` as any} control={control} />,
                }}
                options={workScopeStatusOptions}
                name={`${BASE_FIELD_NAME}.interiorPaint`}
                control={control}
            />
            <FormMultiSelectInput
                inputGroupProps={{
                    label: "Claimed By",
                }}
                options={claimedByOptions}
                name={`${BASE_FIELD_NAME}.claimedBy`}
                control={control}
                placeholder={claimedByLoading ? "Loading options..." : "Select"}
                searchPlaceholder="Search options..."
            />
            {goodwillInteriorPaintOn && (
                <>
                    <FormSelectInput
                        inputGroupProps={{ label: "Interior Paint Goodwill", labelStyle: goodwillLabelStyle }}
                        options={workScopeStatusOptions}
                        name={`${BASE_FIELD_NAME}.goodwillInteriorPaint`}
                        control={control}
                    />
                    <FormMultiSelectInput
                        inputGroupProps={{ label: "Interior Paint Goodwill Claimed By" }}
                        options={claimedByOptions}
                        name={`${BASE_FIELD_NAME}.goodwillInteriorPaintClaimedBy`}
                        control={control}
                        placeholder={claimedByLoading ? "Loading options..." : "Select"}
                        searchPlaceholder="Search options..."
                    />
                </>
            )}
            <FormTextInput
                inputGroupProps={{
                    label: "Total square feet of wall paint needed"
                }}
                placeholder="Total square feet of wall paint needed"
                name={`${BASE_FIELD_NAME}.wallPaintSquareFeet`}
                type="number"
                control={control}
            />
            <FormTextInput
                inputGroupProps={{
                    label: "Total square feet of ceiling paint needed"
                }}
                placeholder="Total square feet of ceiling paint needed"
                name={`${BASE_FIELD_NAME}.ceilingPaintSquareFeet`}
                type="number"
                control={control}
            />
            <DateStampedTextarea
                includeUserName
                inputGroupProps={{
                    label: "Description",
                    wrapperClassName: "xl:col-span-2"
                }}
                rows={3}
                placeholder="Describe the interior paint work needed"
                name={`${BASE_FIELD_NAME}.description`}
                control={control}
            />
        </HomeDetailsWrapperAccordion>
    )
}

export default HomeInteriorPaintForm
